var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',_vm._g(_vm._b({},'Container',_vm.$props,false),_vm.$listeners),[(_vm.img != null && _vm.img != '0')?_c('img',{directives:[{name:"whitelabel-image",rawName:"v-whitelabel-image",value:(`dist/assets/cm/${_vm.img}`),expression:"`dist/assets/cm/${img}`"}],attrs:{"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }